import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import MainLayout from '../components/layout/Main.vue'

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('../views/About.vue')
      },
      {
        path: 'technology',
        name: 'Technology',
        component: () => import('../views/Technology.vue')
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('../views/Products.vue')
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('../views/Contact.vue')
      }
    ]
  },
  {
    path: '/soflux/download/en',
    name: 'soflux_download_en',
    component: () => import('../views/SofluxDownload.vue')
  },
  {
    path: '/soflux/download/cn',
    name: 'soflux_download_cn',
    component: () => import('../views/SofluxDownload.vue')
  },
  {
    path: '/soflux/monitoy/download/en',
    name: 'monitoy_download_en',
    component: () => import('../views/MoniToyDownload.vue')
  },
  {
    path: '/soflux/monitoy/download/cn',
    name: 'monitoy_download_cn',
    component: () => import('../views/MoniToyDownload.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router 